import { Image, ImageProps } from 'expo-image';
import { Link } from 'expo-router';
import { Pressable, StyleSheet } from 'react-native';

import { useClickLogs } from '@fhs-legacy/frontend/src/hooks/use-click-logs';

export type FirstRespondersMonthCardProps = Omit<ImageProps, 'children' | 'source'> & {
  pickUpHref: string;
};

export function FirstRespondersMonthCard({
  pickUpHref,
  ...imageProps
}: FirstRespondersMonthCardProps) {
  const { logFirstRespondersMonthCardClickEvent } = useClickLogs();
  return (
    <Link href={pickUpHref} asChild>
      <Pressable onPress={logFirstRespondersMonthCardClickEvent}>
        <Image
          alt="October is First Responders Month. Order & donate to celebrate 20 years"
          source={require('./first-responders-month-banner.webp')}
          placeholder={{ thumbhash: 'XBgGLwpWa3QOnopqpuhMB5eduAZKW5AC' }}
          {...imageProps}
          style={[styles.firstRespondersMonth, imageProps.style]}
        />
      </Pressable>
    </Link>
  );
}

const styles = StyleSheet.create({
  firstRespondersMonth: {
    aspectRatio: 800 / 811,
  },
});
